import { LOADING_END, LOADING_START } from "./actionType";

export const loadingStart = () => ({
  type: LOADING_START,
})
export const loadingEnd = () => ({
  type: LOADING_END,
})
